import Vue from 'vue'
import Router from 'vue-router'
import store from '@/core/store'
import NProgress from 'nprogress'
// import getPageTitle from '@/core/utils/get-page-title'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '@/modules/home'),
  },
  {
    path: '/search/:words',
    name: 'HomeSearch',
    props: { words: null },
    component: () => import(/* webpackChunkName: "HomeSearch" */ '@/modules/home/Search')
  },
  {
    path: '/pumps/:sku',
    name: 'SinglePump',
    props: { sku: null },
    component: () => import(/* webpackChunkName: "SinglePump" */ '@/modules/pumps/Pump')
  },
  {
    path: '/markets',
    name: 'Groups',
    component: () => import(/* webpackChunkName: "Groups" */ '@/modules/home/Groups'),
  },
  {
    path: '/markets/:market',
    name: 'SingleMarkets',
    props: { market: null },
    component: () => import(/* webpackChunkName: "SingleMarkets" */ '@/modules/home/Markets'),
  },
  {
    path: '/markets/:market/:sector',
    name: 'SingleSectors',
    props: { market: null, sector: null },
    component: () => import(/* webpackChunkName: "SingleSectors" */ '@/modules/home/Sectors'),
  },
  {
    path: '/media-library',
    name: 'MediaLibrary',
    component: () => import(/* webpackChunkName: "MediaLibrary" */ '@/modules/home/MediaLibrary'),
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import(/* webpackChunkName: "Help" */ '@/modules/home/Help'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "Contact" */ '@/modules/home/Contact'),
  },
  // otherwise redirect to home
  // { path: '*', redirect: '/' }
	{ path : '*', redirect : 'Home' }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

// const router = createRouter()

router.beforeResolve(async (to, from, next) => {
  const userToken = store.getters["auth/token"]
  // set page title
  // document.title = getPageTitle(to.meta.title)

  await store.dispatch('auth/refreshToken')
  await store.dispatch('auth/sessionAuth')

  const newUserToken = store.getters["auth/token"]
  if (userToken !== newUserToken) {
    await store.dispatch('home/load')
  }

  if (to.name) {
    NProgress.start()
  }
  
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
